import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ls_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatIDR(value) {
  return "Rp " + Number(value || 0).toLocaleString("id-ID");
}

export function assetImage(asset) {
  if (!asset) return "";
  const url = asset.preview_url || "";
  if (url.startsWith("/api/")) {
    const token = localStorage.getItem("ls_token");
    return `${BACKEND_URL}${url}${token ? `${url.includes("?") ? "&" : "?"}token=${encodeURIComponent(token)}` : ""}`;
  }
  return url;
}

export function downloadUrl(assetId) {
  const token = localStorage.getItem("ls_token");
  return `${API}/download/${assetId}?token=${encodeURIComponent(token || "")}`;
}

export default api;
